import { DEFAULT_LAT, DEFAULT_LON } from '../../constants'

const BRAZIL_BOUNDS = {
  north: 5.271802,
  south: -33.75,
  west: -73.990448,
  east: -34.792215
}

const DEFAULT_CENTER = {
  lat: Number(DEFAULT_LAT),
  lng: Number(DEFAULT_LON)
}

export { BRAZIL_BOUNDS, DEFAULT_CENTER }
